export default __webpack_public_path__ + "static/media/Chinese .f1b3873e.png";